import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/framework/layout/event-bus.js